import TenantManagement from './pages/TenantManagement'
import UserManagement from './pages/UserManagement'
import UserSettings from './pages/UserSettings'
import ReactorSettings from './pages/ReactorSettings'


export default {
  name: 'RcApp',
  components: {
    'TenantManagement': {
      component: TenantManagement
    },
    'UserManagement': {
      component: UserManagement
    },
    'UserSettings': {
      component: UserSettings
    },
    'ReactorSettings': {
      component: ReactorSettings
    },
  }
}